// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/bill-of-materials/${file}.vue`);

export default [
    // Bill of Materials Routes
    {
        path: "/bill-of-materials",
        name: "bill-of-materials",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-list"),
        },
    },
    // Create, Edit, Review Routes
    {
        path: "/bill-of-materials/create",
        name: "bill-of-materials-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials"),
        },
    },
    {
        path: "/bill-of-materials/edit/:id",
        name: "bill-of-materials-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials"),
        },
    },
    {
        path: "/bill-of-materials/review/:id",
        name: "bill-of-materials-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials"),
        },
    },
    // Bill of Materials Processes Routes

    {
        path: "/bill-of-materials-processes/:id",
        name: "bill-of-materials-processes",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-processes"),
        },
    },
    {
        path: "/bill-of-materials-processes/create/:id",
        name: "bill-of-materials-processes-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-processes"),
        },
    },
    {
        path: "/bill-of-materials-processes/edit/:id",
        name: "bill-of-materials-processes-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-processes"),
        },
    },
    {
        path: "/bill-of-materials-processes/review/:id",
        name: "bill-of-materials-processes-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-processes"),
        },
    },
    // Bill of Materials Material Routes
    {
        path: "/bill-of-materials-material/:id",
        name: "bill-of-materials-material",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-material"),
        },
    },
    {
        path: "/bill-of-materials-material/create/:id",
        name: "bill-of-materials-material-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-material"),
        },
    },
    {
        path: "/bill-of-materials-material/edit/:id",
        name: "bill-of-materials-material-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-material"),
        },
    },
    {
        path: "/bill-of-materials-material/review/:id",
        name: "bill-of-materials-material-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-material"),
        },
    },
    // Bill of Materials Assembly Routes
    {
        path: "/bill-of-materials-assembly/:id",
        name: "bill-of-materials-assembly",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-assembly"),
        },
    },
    {
        path: "/bill-of-materials-assembly/create/:id",
        name: "bill-of-materials-assembly-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-assembly"),
        },
    },
    {
        path: "/bill-of-materials-assembly/edit/:id",
        name: "bill-of-materials-assembly-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-assembly"),
        },
    },
    {
        path: "/bill-of-materials-assembly/review/:id",
        name: "bill-of-materials-assembly-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BillOfMaterial",
        },
        components: {
            content: lazyLoad("bill-of-materials-assembly"),
        },
    },
    // Bill of Materials Bulk Update Routes
    {
        path: "/bill-of-materials-bulk-update",
        name: "bill-of-materials-bulk-update",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkBOMUpdate",
        },
        components: {
            content: lazyLoad("bill-of-materials-bulk-update-list"),
        },
    },
    {
        path: "/bill-of-materials-bulk-update/create",
        name: "bill-of-materials-bulk-update-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkBOMUpdate",
            mode: "create",
        },
        components: {
            content: lazyLoad("bill-of-materials-bulk-update"),
        },
    },
    {
        path: "/bill-of-materials-bulk-update/edit/:id",
        name: "bill-of-materials-bulk-update-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkBOMUpdate",
            mode: "edit",
        },
        components: {
            content: lazyLoad("bill-of-materials-bulk-update"),
        },
    },
    {
        path: "/bill-of-materials-bulk-update/review/:id",
        name: "bill-of-materials-bulk-update-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkBOMUpdate",
            mode: "review",
        },
        components: {
            content: lazyLoad("bill-of-materials-bulk-update"),
        },
    },
];